// Live charts redraw every second; recharts animates each redraw by default, which kept
// charts animating non-stop and made scrolling stutter. Draw updates instantly instead.
import { Area, Bar, Line, Pie, Radar, Scatter } from 'recharts';

for (const C of [Line, Area, Bar, Pie, Radar, Scatter] as any[]) {
  C.defaultProps = { ...(C.defaultProps || {}), isAnimationActive: false };
}
